import {
  getActionDescription,
  getApiActions,
  getApiActionsWithPayload,
} from '@binotel-frontend/bnt-common-components';
import {IListSubject} from '@entities/subject';
import {createAction, props} from '@ngrx/store';

const desc = getActionDescription('History');

export namespace HistoryActions {
  export const getHistory = getApiActions(
    desc('Get history'),
    props<{payload: IListSubject[]}>()
  );

  export const saveToHistory = getApiActionsWithPayload(
    desc('Save to history'),
    props<{subjectId: number}>(),
    props<{payload: IListSubject}>()
  );

  export const clearHistory = createAction(desc('Clear history'));
}
